/**
 * EmptyState primitive — centered "nothing to show" block with optional CTA.
 * Ported from Play sc-marketing `ui/empty-state.tsx` (translation log there).
 *
 * @example
 * <EmptyState title="No messages yet." description="Create your first message.">
 *   <LinkButton to="new" variant="primary">New message</LinkButton>
 * </EmptyState>
 */
import type { ReactNode } from 'react';

import { cn } from '../lib/cn';

interface EmptyStateProps {
  title: string;
  description?: string;
  className?: string;
  children?: ReactNode;
}

export function EmptyState({ title, description, className, children }: EmptyStateProps) {
  return (
    <div className={cn('py-12 text-center text-fg-subtle', className)}>
      <p className="text-base font-medium text-fg-muted">{title}</p>
      {description && <p className="mt-2 mb-4 text-sm">{description}</p>}
      {children && <div className="mt-2">{children}</div>}
    </div>
  );
}
